import { render, staticRenderFns } from "./FirebaseMessaging.vue?vue&type=template&id=144c4ad5&scoped=true&"
import script from "./FirebaseMessaging.vue?vue&type=script&lang=ts&"
export * from "./FirebaseMessaging.vue?vue&type=script&lang=ts&"
import style0 from "./FirebaseMessaging.vue?vue&type=style&index=0&id=144c4ad5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144c4ad5",
  null
  
)

export default component.exports